import {AbstractEvent} from "@/modules/base/events";

export class AfterLineupChangedEndEvent extends AbstractEvent {
}
